/* product card gallery - drag vs click

   Stock assets/slideshow.js arms a one-shot document click listener to swallow
   the click a drag-release produces, but its onPointerUp calls
   controller.abort() first, tearing that listener down synchronously before the
   browser dispatches the click - so the safeguard never runs. Fixing it there
   would hit every Slideshow on the site, hence this independent detector. */

(function () {
  'use strict';

  var GALLERY = 'slideshow-component';
  var THRESHOLD = 10;
  /* clears a stale tag if no click ever follows the drag release */
  var STALE_TAG_MS = 500;

  /** pointerId -> { startX, startY, root: Element, dragged: boolean } */
  var gestures = new Map();

  /**
   * @param {PointerEvent} event
   */
  function onPointerDown(event) {
    var root = event.target instanceof Element ? event.target.closest(GALLERY) : null;
    if (!root) return;

    gestures.set(event.pointerId, {
      startX: event.clientX,
      startY: event.clientY,
      root: root,
      dragged: false,
    });
  }

  /**
   * @param {PointerEvent} event
   */
  function onPointerMove(event) {
    var gesture = gestures.get(event.pointerId);
    if (!gesture || gesture.dragged) return;

    var dx = event.clientX - gesture.startX;
    var dy = event.clientY - gesture.startY;
    if (Math.abs(dx) <= THRESHOLD && Math.abs(dy) <= THRESHOLD) return;

    gesture.dragged = true;
    gesture.root.ygSuppressClick = true;
    clearTimeout(gesture.root.ygSuppressClickTimer);
    gesture.root.ygSuppressClickTimer = setTimeout(function () {
      gesture.root.ygSuppressClick = false;
    }, STALE_TAG_MS);
  }

  /**
   * @param {PointerEvent} event
   */
  function onPointerEnd(event) {
    gestures.delete(event.pointerId);
  }

  /**
   * @param {MouseEvent} event
   */
  function onClickCapture(event) {
    var root = event.target instanceof Element ? event.target.closest(GALLERY) : null;
    if (!root || !root.ygSuppressClick) return;

    root.ygSuppressClick = false;
    clearTimeout(root.ygSuppressClickTimer);
    event.preventDefault();
    event.stopPropagation();
  }

  /* Capture phase throughout: pointermove must be seen before Slideshow's
     bubble-phase document listener calls stopImmediatePropagation on it, and
     click before the anchor's default navigation and product-card.js's own
     bubble-phase navigateToProduct. */
  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('pointermove', onPointerMove, true);
  document.addEventListener('pointerup', onPointerEnd, true);
  document.addEventListener('pointercancel', onPointerEnd, true);
  document.addEventListener('click', onClickCapture, true);
})();
